export default __webpack_public_path__ + "static/media/map.003b6b93.webp";